import React from 'react';
import type { SignalrConnection } from 'services/relay/signalr-connection';

export const SignalrConnectionContext = React.createContext<SignalrConnection | null>(null);
